import React from 'react'
import PropTypes from 'prop-types'
import { withTranslationCustom } from 'lib/i18next'
import {
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from 'react-share'

import './some-share.pcss'

const SomeShare = ({ url, t }) => {
    return (
        <div className="some-share">
            <div className="some-share__share-row">
                <FacebookShareButton
                    url={url}
                >
                    <div className="some-share__body">
                        <div className="some-share__icon">
                            <FacebookIcon borderRadius={5} />
                        </div>
                        {t('common:someShare.facebook')}
                    </div>
                </FacebookShareButton>
            </div>
            <div className="some-share__share-row">
                <TwitterShareButton
                    url={url}
                >
                    <div className="some-share__body">
                        <div className="some-share__icon">
                            <TwitterIcon borderRadius={2} />
                        </div>
                        {t('common:someShare.twitter')}
                    </div>
                </TwitterShareButton>
            </div>
            <div className="some-share__share-row">
                <WhatsappShareButton
                    url={url}
                >
                    <div className="some-share__body">
                        <div className="some-share__icon">
                            <WhatsappIcon borderRadius={2} />
                        </div>
                        {t('common:someShare.whatsapp')}
                    </div>
                </WhatsappShareButton>
            </div>
        </div>
    )
}

SomeShare.propTypes = {
    url: PropTypes.string.isRequired,
}

export default withTranslationCustom(['common'])(SomeShare)
